// extracted by mini-css-extract-plugin
export var container = "_7q-0";
export var fallback = "_7q-5";
export var fallbackIcon = "_7q-6";
export var hidden = "_7q-2";
export var image = "_7q-3";
export var loaded = "_7q-4";
export var placeholder = "_7q-1";